<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hMXBt/tc-custom/9781439676189.jpg?1702530190326" alt="This image is the cover for the book Lake Michigan Triangle, The, American Legends"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lake Michigan Triangle, The, American Legends
      </h1>
      <p class="bookDescription body article font2">
        <p><b>What disturbing secrets surround the cold, deep waters of Lake Michigan?</b></p><br/><p>Sudden violent storms and rocky shoals have claimed the lives of countless mortals foolish enough to brave the treacherous surf of Lake Michigan. But is there another, unnatural force at work? A force that spirited away a ship's captain from a locked cabin without a trace? A force that caused a perfectly airworthy jet to fly into the waves, taking all its passengers to a watery death? Perhaps these tragedies are linked to numerous UFO sightings over the lake. Or perhaps a clue might be found in the prehistoric Stonehenge-like structures discovered deep beneath the crystalline blue surface.</p><br/><p> Historian and storyteller Gayle Soucek will explore the mysteries behind the area known as the Lake Michigan Triangle.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gayle Soucek
      </h2>
      
      <p class="authorDescription body article">Gayle Soucek is an author, historian and freelance editor with more than a dozen books and numerous magazine articles to her credit, including <I>Haunted Door County; Door County Tales: Shipwrecks, Cherries and Goats on the Roof</I>; and <I>Chicago Calamities: Disaster in the Windy City</I>. Gayle and her photographer husband divide their time between their home in a Chicago suburb and a second home in Gills Rock, Wisconsin, directly overlooking the Death's Door passage. It's this proximity to the rich history and unexplained events that occur along the Lake Michigan shoreline that inspired this book on the Lake Michigan Triangle.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4ae01afe